import axios from 'axios'

import {HOST} from '../../config'

export const ActionConst = {
  SET_ACESSOS: 'CO_ACESSO_SET_ACESSOS',
  SET_FILTRO: 'CO_ACESSO_SET_FILTRO',
  SET_SORT: 'CO_ACESSO_SET_SORT',
  SET_DATASOURCE: 'CO_ACESSO_SET_DATASOURCE',
  IS_FETCHING: 'CO_ACESSO_IS_FETCHING',
  ADD: 'CO_ACESSO_ADD',
  EDIT: 'CO_ACESSO_EDIT',
  REMOVE: 'CO_ACESSO_REMOVE'
}

function _setAcessos (acessos) {
  return {
    type: ActionConst.SET_ACESSOS,
    acessos
  }
}

function _setDataSource (dataSource) {
  return {
    type: ActionConst.SET_DATASOURCE,
    dataSource
  }
}

// args - {search, situacao}
export function setFiltro (args) {
  return {
    type: ActionConst.SET_FILTRO,
    args
  }
}

function _setSort (sort) {
  return {
    type: ActionConst.SET_SORT,
    sort
  }
}

function _isFetching (isFetching) {
  return {
    type: ActionConst.IS_FETCHING,
    isFetching
  }
}

function _sort (sort, dataSource) {
  if (sort.property && sort.property !== "") {
    return dataSource.sort((a, b) => {
      let valueA = String(a[sort.property]).toLowerCase()
      let valueB = String(b[sort.property]).toLowerCase()

      if (sort.asc) {
        if (valueA < valueB){
          return -1;
        }else if (valueA > valueB){
          return  1;
        }else{
          return 0;
        }
      } else {
        if (valueA > valueB){
          return -1;
        }else if (valueA < valueB){
          return  1;
        }else{
          return 0;
        }
      }
    })
  }
}

function _aplicarFiltro (args) {
  let {filter_property, expressao, acessos, sort} = args
  let dataSource = []

  if (acessos && acessos.length>0) {
    if (expressao && expressao !== ''){
      expressao = String(expressao).toUpperCase()

      dataSource = acessos.filter((item) => {
        return filter_property.find((property) => {
          let value = String(item[property]).toUpperCase()
          return value.indexOf(expressao) > -1
        })
      })
    } else {
      dataSource = [...acessos]
    }
  }
  return _sort(sort, dataSource)
}

export function buscar () {
  return (dispatch, getState) => {
    let {filter_property, expressao, acessos, sort} = getState().coAcesso

    dispatch(_isFetching(true))
    setTimeout(()=>{
      let dataSource = _aplicarFiltro({filter_property, expressao, acessos, sort})
      dispatch(_setDataSource(dataSource))
      dispatch(_isFetching(false))
    })
  }
}

export function qsort (property) {
  return (dispatch, getState) => {
    let {sort} = getState().coAcesso
    let asc = true
    if (sort.property === property) {
      asc = !sort.asc
    }
    dispatch(_setSort({property, asc}))
    dispatch(buscar())
  }
}

function _getAcessos () {
  return (dispatch, getState) => {
    let url = `${HOST}/api/mobile/accounts`

    return axios.get(url).then(response => {
      let {accounts} = response.data
      dispatch(_setAcessos(accounts))
    }).catch((error) => {
      if (error.response) {
        error = error.response.data.error
      }
      return Promise.reject(error)
    })
  }
}

export function load () {
  return (dispatch) => {
    dispatch(_isFetching(true))

    return Promise.all([
      dispatch(_getAcessos())
    ]).then(()=>{
      dispatch(buscar())
    }).catch((error)=>{
      dispatch(_isFetching(false))
      return Promise.reject(error)
    })
  }
}

function _remove (id) {
  return {
    type: ActionConst.REMOVE,
    id
  }
}

export function remove (id) {
  return (dispatch) => {
    let url = `${HOST}/api/mobile/accounts/${id}`

    return axios.delete(url).then(response => {
      dispatch(_remove(id))
      return response
    }).catch((error) => {
      if (error.response) {
        error = error.response.data.error
      }
      return Promise.reject(error)
    })
  }
}

function _add (acesso) {
  return {
    type: ActionConst.ADD,
    acesso
  }
}

function _edit (acesso) {
  return {
    type: ActionConst.EDIT,
    acesso
  }
}

export function adicionar ({id, acesso}) {
  return (dispatch) => {
    if (id) {
      acesso.id = id
      dispatch(_add(acesso))
    } else {
      dispatch(_edit(acesso))
    }
    dispatch(buscar())
  }
}






// WEBPACK FOOTER //
// ./src/actions/acesso/CoAcesso.js